import { ReactNode } from "react";
import { ErrorMap } from "../api/fetch";
import { Error as RobotErrors } from "../types/common/RobotErrors";
import { InfobuttonTextsContainer } from "../types/admin/User";
import { Infotext } from "../api/InfobuttonTextsTypes";
import { PlacementType } from "mta-rkvr-styles";

export function splitArray(array: [any, any][], length: number) {
  const chunks = [],
    n = array.length;
  let i = 0;
  while (i < n) {
    chunks.push(array.slice(i, (i += length)));
  }
  return chunks;
}

export const flatten = <T>(arrays: T[][]) => {
  const flatArray: T[] = [];
  arrays.forEach((array) => {
    array.forEach((element) => {
      flatArray.push(element);
    });
  });
  return flatArray;
};

export interface ParametrisedString {
  key: string;
  params: string[];
}

export function errorMessageToAppropriate(errorMessage: string): string | ParametrisedString {
  const parts = errorMessage.split(":");
  if (parts.length == 1) {
    return parts[0];
  }
  return { key: parts[0], params: [parts[1]] };
}

export const createPopoverExplination = (target: string, message: string) => {
  return {
    content: message,
    placement: "right" as PlacementType,
    target: target,
  };
};

export const getInfotextInner = (code: string, view: string, infobuttonTexts: InfobuttonTextsContainer) => {
  return getInfotextInnerGeneral(code, view, infobuttonTexts.complexTexts);
};

// Unit management
export const getInfotextUnitManagement = (code: string, view: string, infobuttonTexts: InfobuttonTextsContainer) => {
  return getInfotextInnerGeneral(code, view, infobuttonTexts.unitManagementTexts);
};

// Investment
export const getInfotextInvestment = (code: string, view: string, infobuttonTexts: InfobuttonTextsContainer) => {
  return getInfotextInnerGeneral(code, view, infobuttonTexts.investmentProjectTexts);
};

// Generalized
export const getInfotextInnerGeneral = (code: string, view: string, infobuttonTexts: Infotext[] | undefined) => {
  const txt = getInfotextStrGeneral(code, view, infobuttonTexts);
  if (txt != undefined) {
    return createPopoverExplination(view + "-info-" + code, txt);
  } else {
    return undefined;
  }
};

// UM
const getInfotextStrGeneral = (code: string, view: string, infobuttonTexts: Infotext[] | undefined) => {
  return infobuttonTexts?.find((r) => r.vaade === view && r.kood === code)?.tekst;
};

export const robotErrorsToStrings = (t: any, errorMap: ErrorMap) => {
  const errors: string[] = [];

  [
    RobotErrors.OBJECT_ATRIBUTE_REQ_PARAM_REQUIRED,
    RobotErrors.REGISTRY_PART_CLOSED,
    RobotErrors.NUMBER_NOT_FOUND,
    RobotErrors.CADASTRAL_CODE_NOT_FOUND_OR_CLOSED,
  ]
    .filter((error) => errorMap.hasOwnProperty(error))
    .forEach((error) => errors.push(t(`common.error.robot.${error}`)));

  errorMap[RobotErrors.CADASTRAL_CODE_IN_REGISTRY]?.forEach((error) => {
    errors.push(
      t(`common.error.robot.${RobotErrors.CADASTRAL_CODE_IN_REGISTRY}`, {
        kyTunnus: error.kyTunnus,
        roNumber: error.roNumber,
      }),
    );
  });

  errorMap[RobotErrors.CADASTRAL_CODE_IN_REGISTRY_MULTIPLE]?.forEach((error) => {
    errors.push(
      t(`common.error.robot.${RobotErrors.CADASTRAL_CODE_IN_REGISTRY_MULTIPLE}`, {
        kyTunnus: error.kyTunnus,
        roNumbers: error.roNumbers.join(", "),
      }),
    );
  });

  return errors;
};

export const joinElements = (list: ReactNode[] | undefined, separator = "; ") => {
  return list?.reduce((prev, curr) => [prev, separator, curr]);
};

export const openLink = (link: string | undefined) => {
  window.open(link, "_blank");
};

export function numberWithSpaces(x: number | undefined) {
  if (x != undefined) {
    return numberWithSpacesInner(x);
  }
  return undefined;
}

export function numberWithSpacesInner(x: number) {
  const strfied = x.toString();
  let splitter: string | undefined = undefined;
  if (strfied.includes(".")) {
    splitter = ".";
  } else if (strfied.includes(",")) {
    splitter = ",";
  }
  if (splitter) {
    const parts = strfied.split(splitter);
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(splitter);
  } else {
    return strfied.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
}
